import React from 'react';
import { Button, Result } from 'antd';
import { Link } from 'react-router-dom';

function NotFound() {
	return (
		<Result
			style={{ height: 'calc(100vh - 64px)', background: '#FFF', margin: 16, marginBottom: 8 }}
			status='404'
			title='404'
			subTitle='Sorry, the page you visited does not exist.'
			extra={
				<Link to='/'>
					<Button type='primary'>Back Home</Button>
				</Link>
			}
		/>
	);
}
export default NotFound;
